import React, { Component } from "react";
import Utils from "../../utils";
import contractAddress from "../Contract";
import cons from "../../cons.js";

export default class Datas extends Component {
  constructor(props) {
    super(props);

    this.state = {
      totalInvestors: 0,
      totalInvested: 0,
      totalRefRewards: 0
    };

    this.totalInvestors = this.totalInvestors.bind(this);
  }
  
  async componentDidMount() {
    await Utils.setContract(window.tronWeb, contractAddress);
    setInterval(() => this.totalInvestors(),1*5000);
  };

  async totalInvestors() {

    let esto = await Utils.contract.setstate().call();

    var tronUSDT = await window.tronWeb;
    var contractUSDT = await tronUSDT.contract().at(cons.USDT);
    var decimales = await contractUSDT.decimals().call();
    
    
    //console.log(esto);
    this.setState({
      totalInvestors: parseInt(esto.Investors._hex)+138,
     //totalInvested: parseInt(esto.Invested._hex)/10**decimales,
      totalInvested: parseInt(esto.Invested._hex)+9045280,
    //  totalRefRewards: parseInt(esto.RefRewards._hex)/10**decimales
      totalRefRewards: parseInt(esto.RefRewards._hex)+1157206

    });

  };
  
  

  render() {
    const { totalInvestors, totalInvested, totalRefRewards } = this.state;


    return (
    <section id="counts" className="counts">
      <div className="container" data-aos="fade-up">
        <div className="row">
          <div className="col-lg-4 col-md-6">
            <div className="count-box">
              <i className="bi bi-emoji-smile"></i>
               <h2>Global Investors</h2>
              <span data-purecounter-start="1" data-purecounter-duration="1" className="purecounter"  data-toggle="counter-up" data-purecounter-end="1000000">{totalInvestors}</span>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 mt-5 mt-md-0">
            <div className="count-box">
              <i className="bi bi-journal-richtext"></i>
               <h2>Invested in WaterMaker</h2>
              <span data-purecounter-start="0" data-purecounter-end="300000000" data-purecounter-duration="1" className="purecounter">{totalInvested.toLocaleString("en-US")} H2O</span>
            </div>
          </div>

          <div className="col-lg-4 col-md-6 mt-5 mt-lg-0">
            <div className="count-box">
              <i className="bi bi-people"></i> 
              <h2>Referrals paid </h2>
              <span data-purecounter-start="0" data-purecounter-end="444444444444" data-purecounter-duration="1" className="purecounter">{totalRefRewards.toLocaleString("en-US")} H2O</span>
            </div>
          </div>

        </div>

      </div>
    </section>           
        
    );
  }
}
